// Backend sends "N spots left" as plain text; make the singular case read "1 spot left".
const formatSpotsLeft = (value) => {
  if (typeof value !== "string") return value;
  return value.replace(/\b1[\s_]spots\b/gi, (match) => match.slice(0, -1));
};

export default formatSpotsLeft;
